import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../layout/Layout';
import '../css/gallery.css';
import { useCloudinaryFolder } from '../hooks/useCloudinaryImages';

export default function Beauty() {
  const [model, setModel] = useState(false);
  const [tempimgSrc, setTempImgSrc] = useState('');
  const { images, loading, error } = useCloudinaryFolder('beauty');

  const getImg = (imgSrc) => {
    setTempImgSrc(imgSrc);
    setModel(true);
  };

  return (
    <Layout>
      {error ? <Alert variant="danger">{error}</Alert> : null}

      <div
        onClick={() => setModel(false)}
        className={model ? 'model open' : 'model'}
      >
        <img src={tempimgSrc} alt="" />
      </div>

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : images.length > 0 ? (
        <div className="gallery">
          {images.map((item) => (
            <div className="pics" key={item.id} onClick={() => getImg(item.url)}>
              <img src={item.thumbnail} style={{ width: '100%' }} alt={item.id} />
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-5 text-muted">
          No hay imagenes publicadas en esta galeria.
        </div>
      )}
    </Layout>
  );
}
